import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer, LoaderFunctionArgs } from 'react-router-dom'
import useStockStore from 'src/components/routes/stock/store'

export default async function loader({ params }: LoaderFunctionArgs) {
  await isAppStateReady()

  useStockStore.getState().resetTendersSlice()

  const suppliers = useStockStore.getState().getSuppliers()
  const items = useStockStore.getState().getItems()
  const brands = useStockStore.getState().getBrands()
  const units = useStockStore.getState().getStockUnits()

  const promises: Promise<unknown>[] = [suppliers, items, brands, units]

  if (params.tenderId) {
    promises.push(useStockStore.getState().getTender(params.tenderId))
  } else {
    useStockStore.getState().initNewTender()
  }

  return defer({
    data: Promise.all(promises)
      .then(() => true)
      .catch((error) => {
        logger.error('Loader Manage Tender error: ', error)
        return false
      }),
  })
}
